import React from "react";
import ReactDOM from "react-dom";
import {observer, inject} from "mobx-react";
import {observable, computed} from 'mobx';
import ReactDataSheet from "@components/react-datasheet";
import axios from "axios";
import getBoxPadUrl from "@utils/getBoxPadUrl"
import {QuantityEdit} from "../Products/QuantityEdit";


@inject("store")
@observer
export default class EditProduct extends React.Component {
    @observable Product = null;
    @observable Siblings = [];
    @observable SplitOrderInformation = [];
    @observable ViewForcastForSku = "";
    @observable ViewOrdersplitForSku = "";
    @observable errorMessage = null;

    @observable OrderStatusId = null;

    @observable processingUpdates = [];
    @observable currentOrderLines = 0;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const orderStore = this.props.store.order;
        const activeOrder = orderStore.activeOrder;
        //this.currentOrderLines = activeOrder.ProductList.find(product => product.GroupKey === this.props.GroupKey).OrderLines.length;
//        this.getProductData(this.props);

    }

    componentWillReceiveProps(nextProps) {

        if (!this.Product || nextProps.GroupKey !== this.Product.GroupKey) {
            // Refresh this if the orderstatus is changed or sku is updated
            //console.log("componentWillReceiveProps -> getProductData", nextProps.GroupKey, "thisProduct", this.Product);
            //this.getProductData(nextProps);
        }
    }

    componentWillReact() {
        const orderStore = this.props.store.order;
        const activeOrder = orderStore.activeOrder;
        if (activeOrder) {
            // const product = activeOrder.ProductList.find(product => product.GroupKey === this.props.GroupKey);
            // const orderLinesCount = product ? product.OrderLines.length : 0;
            // if (orderLinesCount !== this.currentOrderLines) {
            //     //this.getProductData(this.props);
            //     this.currentOrderLines = orderLinesCount;
            // }
        }

    }


    componentWillUnmount() {
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to component unmount.');
            console.debug("request cancelled");
        }
    }


    render() {
        const orderStore = this.props.store.order;
        const navigation = this.props.store.navigation;

        const product = this.Product;
        const siblings = this.Siblings;
        const order = orderStore.activeOrder;
        const showDetails = this.props.showDetails || false;
        
        if(order === null || order.ProductList ===null)
        {return;}
        

        const orderLines = order.ProductList.find(product => product.GroupKey === this.props.GroupKey).OrderLines;

        if (this.errorMessage) {
            return (<div>Error: {this.errorMessage}</div>);
        }


        return (<React.Fragment>
            <span tabIndex="0" className="data-grid-container">
            <table className="data-grid">
                <tbody>
                {orderLines.map(orderLine => {
                    
                    const stockStatus = orderLine.PropertyValueByKey("StockStatus");
                    let stockInfo = "";
                    switch(stockStatus){
                        case "PreBook":
                            stockInfo = "*Förbokad*";
                            break;
                    }
                    
                    return (
                        <tr key={orderLine.OrderLineId}>
                            <td className="cell-product-and-quantity cell clip read-only">
                                <img alt="" className=""
                                     src={orderLine.PrimaryImageUrl
                                         ? getBoxPadUrl(orderLine.PrimaryImageUrl,
                                             160,
                                             240,
                                             navigation.ImageFormat,
                                             "ffffff").url
                                         : "/umbraco/Ucommerce/images/ui/image-not-found.png"
                                     }
                                     style={{width: 40, float: "left", marginRight: 7}}/>
                                <div className="detail-container">
                                    <span className="title">{orderLine.Name}</span> {stockInfo}<br/>
                                    <span className="detail">{orderLine.VariantSku || orderLine.Sku}</span><br/>
                                    <span className="detail">{orderLine.PriceExFormatted} {order.Currency}</span>
                                </div>

                                <QuantityEdit
                                    key={orderLine.Sku + "_" + orderLine.VariantSku}
                                    orderStore={this.props.store.order}
                                    sku={orderLine.Sku}
                                    variantSku={orderLine.VariantSku}
                                    //quantity={this.state.quantity}
                                    increments={orderLine.PropertyValueByKey("PackSize") || 1}
                                />
                            </td>

                        </tr>
                    );
                })}
                
                </tbody>
            </table>
            </span>

        </React.Fragment>);
    }
}